import { defineComponent as _defineComponent } from 'vue'
import type { SponsoredAdFragment } from '@/pages/graphql/fragments/SponsoredAd.fragment';
import type { Maybe } from '@/helpers/types';

import { computed } from 'vue';
import { SingleTitleSR } from '@/components/sponsored-recommendations/types';

import { SnowplowContext, SnowplowModuleContext } from '@/helpers/tracking/providers/snowplow-contexts';


export default /*#__PURE__*/_defineComponent({
  __name: 'SponsoredRecommendationImage',
  props: {
    sponsoredAdCampaign: null,
    lazy: { type: Boolean, default: true },
    additionalContexts: { default: () => [] },
    isCinemaSR: { type: Boolean, default: false }
  },
  emits: ["onPosterClickOut", "imageError"],
  setup(__props: any) {

const props = __props as { sponsoredAdCampaign: NonNullable<SponsoredAdFragment['campaign']> & { node: SingleTitleSR }, lazy: boolean, additionalContexts: (SnowplowModuleContext | SnowplowContext)[], isCinemaSR: boolean };





const campaignNode = computed(() => props.sponsoredAdCampaign.node);

// Disclaimer text
const promotionalText = computed(
	() => props.sponsoredAdCampaign?.promotionalText || campaignNode.value?.content.originalReleaseYear?.toString()
);

// HACK: APPLE PLUS - display disclaimer text
const hasDisclaimerText = computed(
	() =>
		props.sponsoredAdCampaign?.name.toUpperCase().includes('APPLEPLUS') &&
		props.sponsoredAdCampaign?.promotionalText
);

return { __sfc: true,props, campaignNode, promotionalText, hasDisclaimerText }
}

})